import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/useAppSelector";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import styles from "./BillingCards.module.scss";
import CustomButton from "../../../../components/ui/CustomButton/CustomButton";
import PaymentMethodEmpty from "../../../../components/shared/PaymentMethodEmpty/PaymentMethodEmpty";
import BillingCard from "../BillingCard/BillingCard";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import { useGetPaymentMethodsQuery } from "../../../../api/queries";
import { IUser } from "../../../../models/User";

const BillingCards = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = useAppSelector((state) => state.userProfileSlice.user) as IUser;
  const { data } = useAppSelector((state) => state.userPaymentMethodsSlice);
  const { refetch } = useGetPaymentMethodsQuery(user.id);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const message = searchParams.get("message");
      if (message && user) {
        dispatch(openSuccessMessage(t(message)));
        refetch();
        navigate("/settings/billing/cards");
      }
    }
  }, [location]);

  const clickOnAddNewCard = () => {
    navigate("/settings/billing/cards/new");
  };

  if (data.length === 0) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>{t("BillingInformation")}</h2>
        <PaymentMethodEmpty />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("BillingInformation")}</h2>
      <div className={styles.wrapper}>
        {data.map((el) => {
          return <BillingCard key={el.id} paymentMethod={el} getAllPaymentMethod={refetch} />;
        })}
      </div>
      <div className={styles.btnWrapper}>
        <CustomButton
          text={t("AddNewCard")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={clickOnAddNewCard}
        />
      </div>
    </div>
  );
};

export default BillingCards;
